/**
 * UserMessage - Minimalist mission control styled user messages
 *
 * Features:
 * - Compact layout with subtle role indicator
 * - Amber accent for user identity
 * - Monospace text for technical feel
 * - Retro mission control aesthetic
 */

import { ChatMessage } from '../../types/chat'

interface UserMessageProps {
  message: ChatMessage
}

function UserMessage({ message }: UserMessageProps) {
  return (
    <div className="group">
      {/* Role indicator - subtle, inline */}
      <div className="flex items-center gap-2 mb-1">
        <div
          className="w-1.5 h-1.5 rounded-full"
          style={{ backgroundColor: '#ffcc66' }}
        />
        <span className="text-xs font-mono uppercase tracking-wider text-retro-dim">
          operator
        </span>
      </div>

      {/* Message content */}
      <div className="pl-3.5 border-l border-retro-border">
        <p className="text-dark-700 whitespace-pre-wrap break-words leading-relaxed">
          {message.content}
        </p>
      </div>
    </div>
  )
}

export default UserMessage
